import { Injectable } from '@angular/core';
import { Y42FeatureType, Y42Metadata } from '@y42/json-schema';
import { combineLatest, map, Observable, of } from 'rxjs';
import { FeatureAggregationService } from './feature-aggregation.service';

@Injectable({ providedIn: 'root' })
export class FeatureTagsQueryService {
  constructor(private readonly featureAggregation: FeatureAggregationService) {}

  private readonly featureToTagsDefinition: Record<Y42FeatureType, Observable<Y42Metadata['tags']>> = {
    [Y42FeatureType.StatusAlert]: this.featureAggregation
      .getByFeatureType(Y42FeatureType.StatusAlert)!
      .query.items$.pipe(map((items) => [...new Set(items.map((item) => item.tags).flat())])),

    [Y42FeatureType.Export]: this.featureAggregation
      .getByFeatureType(Y42FeatureType.Export)!
      .query.items$.pipe(map((items) => [...new Set(items.map((item) => item.tags).flat())])),

    [Y42FeatureType.Integration]: this.featureAggregation
      .getByFeatureType(Y42FeatureType.Integration)!
      .query.items$.pipe(map((items) => [...new Set(items.map((item) => item.tags).flat())])),

    [Y42FeatureType.Lineage]: of([]),

    [Y42FeatureType.UiModel]: this.featureAggregation
      .getByFeatureType(Y42FeatureType.UiModel)!
      .query.items$.pipe(map((items) => [...new Set(items.map((item) => item.tags).flat())])),

    [Y42FeatureType.SqlModel]: this.featureAggregation
      .getByFeatureType(Y42FeatureType.SqlModel)!
      .query.items$.pipe(map((items) => [...new Set(items.map((item) => item.tags).flat())])),

    [Y42FeatureType.Orchestration]: this.featureAggregation
      .getByFeatureType(Y42FeatureType.Orchestration)!
      .query.items$.pipe(map((items) => [...new Set(items.map((item) => item.tags).flat())])),

    [Y42FeatureType.VisualizationDashboard]: this.featureAggregation
      .getByFeatureType(Y42FeatureType.VisualizationDashboard)!
      .query.items$.pipe(map((items) => [...new Set(items.map((item) => item.tags).flat())])),

    // TODO
    [Y42FeatureType.VisualizationWidget]: of([]),
    // TODO
    [Y42FeatureType.VisualizationFilter]: of([]),
    // TODO
    [Y42FeatureType.VisualizationTheme]: of([]),
    // TODO
    [Y42FeatureType.Catalog]: of([]),
  };

  readonly tags$ = (() => {
    const allTags$ = Object.values(this.featureToTagsDefinition).reduce<Array<Observable<Y42Metadata['tags']>>>(
      (acc, tags$) => [...acc, tags$],
      [],
    );

    return combineLatest(allTags$).pipe(map((tags) => [...new Set(tags.flat())]));
  })();

  getTagsByFeatureType(featureType: Y42FeatureType): Observable<Y42Metadata['tags']> {
    return this.featureToTagsDefinition[featureType];
  }
}
